import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsPerformanceDashboardRoute } from '@jira/router-routes__admin-pages-performance-routes/src/globalSettingsPerformanceDashboardRoute.tsx';
import { notFoundEntrypoint } from '@jira/spa-apps__error-pages-not-found/src/notFoundEntrypoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import { PerformanceMonitorDashboardEntryPoint } from './ui/spa/admin-pages/performance/dashboard/index.tsx';
import { performanceLayoutWithRightSidebar } from './ui/performanceLayoutWithRightSidebar.tsx';

const notFoundPageEntrypoint = createPageEntryPoint({
	main: notFoundEntrypoint,
});

export const globalSettingsPerformanceDashboardRouteEntry: Route = createEntry(
	globalSettingsPerformanceDashboardRoute,
	() => ({
		group: 'global-settings',
		entryPoint: () => {
			if (!(fg('enable_jira_apm_m2') || fg('enable_cfo_dashboard'))) {
				return notFoundPageEntrypoint;
			}
			return PerformanceMonitorDashboardEntryPoint;
		},

		layout: performanceLayoutWithRightSidebar,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
			menuId: MenuIdSettings,
		},

		resources: [...getNavigationResources(), navigationSidebarGlobalResource],
		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
